import ProjectModel      from '@models/map/ProjectModel';
import { clientEndpoint } from '@/appConfig';

/**
 * L'adresse publique d'un projet, telle qu'on la donne à un visiteur.
 *
 * Le slug appartient au projet, le chemin aussi. L'ancien `/maps/{slug}` reste servi par le client,
 * qui y redirige les liens déjà diffusés (voir `LegacyMapRedirect`).
 */
export default function publicProjectLink(project: ProjectModel) {
	return `${clientEndpoint}/projects/${project.slug}`;
}
